module.exports = __webpack_public_path__ + "static/media/utsushimi-camie.a65dbc59.png";